import React from 'react';

import classes from './styles.module.scss';
import zoomInIcon from '../../../../../assets/images/create-meeting/zoomIn.svg';
import zoomOutIcon from '../../../../../assets/images/create-meeting/zoomOut.svg';

function calculateZoomForFrames(total, desiredCount) {
  const zoom = (desiredCount / total) * 100;
  return zoom;
}

// Calculate adaptive zoom step based on video duration
// Longer videos need smaller steps for smoother zooming
function getZoomStep(duration) {
  if (duration <= 60) {
    // Short videos (< 1 min): 10% steps
    return 10;
  }
  if (duration <= 300) {
    // Medium videos (1-5 min): 5% steps
    return 5;
  }
  if (duration <= 600) {
    // Long videos (5-10 min): 2% steps
    return 2;
  }
  // Very long videos (> 10 min): 1% steps
  return 1;
}

export default function Zoom({ zoom, setZoom, frameWidth, frameCount, duration }) {
  const zoomStep = getZoomStep(duration || 0);
  
  return (
    <div className={classes.Zoom}>
      <button
        type="button"
        className={classes.zoomButton}
        onClick={() => setZoom((prevState) => Math.min(100, +prevState + zoomStep))}
      >
        <img src={zoomInIcon} alt="Zoom In" />
      </button>
      <input
        type="range"
        className={classes.input}
        value={zoom}
        onChange={(event) => setZoom(event.target.value)}
        min="0"
        max="100"
        step={zoomStep}
      />
      <button
        type="button"
        className={classes.zoomButton}
        onClick={() => setZoom((prevState) => Math.max(0, +prevState - zoomStep))}
      >
        <img src={zoomOutIcon} alt="Zoom Out" />
      </button>
      <button
        type="button"
        className={classes.zoomButton}
        onClick={() => {
          const totalFrames = frameCount || 0;
          if (!totalFrames) {
            setZoom(100);
            return;
          }
          const safeFrameWidth = Math.max(1, frameWidth || 1);
          const desiredCount = Math.floor(991 / safeFrameWidth) || 1;
          const newZoom = Math.min(
            100,
            calculateZoomForFrames(totalFrames, desiredCount)
          );
          setZoom(newZoom);
        }}
      >
        Fit full video in editor
      </button>
    </div>
  );
}
